import React from 'react';
import { CHART_PALETTE, SURFACE } from './chartColors';

interface MetricCardProps {
  label: string;
  value: string | number;
  subtitle?: string;
  colorIndex?: number;
  icon?: React.ReactNode;
}

const MetricCard: React.FC<MetricCardProps> = ({
  label,
  value,
  subtitle,
  colorIndex = 0,
  icon,
}) => {
  const color = CHART_PALETTE[colorIndex % CHART_PALETTE.length];

  return (
    <div
      className="stat-card relative overflow-hidden"
      style={{
        background: `linear-gradient(135deg, ${color.light}, white)`,
        borderColor: `${color.base}20`,
      }}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="text-xs font-medium mb-2" style={{ color: SURFACE.textSecondary }}>
            {label}
          </div>
          <div
            className="text-3xl font-bold leading-none tabular-nums"
            style={{ color: color.dark }}
          >
            {value}
          </div>
          {subtitle && (
            <div className="text-xs mt-2" style={{ color: SURFACE.textMuted }}>
              {subtitle}
            </div>
          )}
        </div>

        {/* Icon or decorative element */}
        {icon ? (
          <div
            className="flex-shrink-0 w-10 h-10 rounded-lg flex items-center justify-center"
            style={{
              background: `linear-gradient(135deg, ${color.gradient[0]}, ${color.gradient[1]})`,
              color: 'white',
            }}
          >
            {icon}
          </div>
        ) : (
          <div
            className="flex-shrink-0 w-10 h-10 rounded-lg flex items-center justify-center"
            style={{
              background: `linear-gradient(135deg, ${color.gradient[0]}20, ${color.gradient[1]}20)`,
            }}
          >
            {/* Progress ring decoration */}
            <svg width="28" height="28" viewBox="0 0 28 28">
              <circle cx="14" cy="14" r="10" fill="none" stroke={`${color.base}20`} strokeWidth="3" />
              <circle
                cx="14"
                cy="14"
                r="10"
                fill="none"
                stroke={color.base}
                strokeWidth="3"
                strokeDasharray={`${Math.PI * 20 * 0.72} ${Math.PI * 20}`}
                strokeLinecap="round"
                transform="rotate(-90 14 14)"
              />
            </svg>
          </div>
        )}
      </div>
    </div>
  );
};

export default MetricCard;
